module.exports = __webpack_public_path__ + "media/careless_whisper.f09733b1.mp3";